import React, { useState } from 'react';
import { Combobox, FormField, Layout } from '@vwfs-bronson/bronson-react';
import { useField } from 'formik';
import { InfoIcon, useAnalyticsActionTracker } from '@cp-shared-15/frontend-ui';
import { useTranslation } from 'react-i18next';

export const MonthlyPaymentDaySelection: React.FC<{ name: string; testId: string }> = ({ name, testId }) => {
    const { t } = useTranslation('financial-details');
    const translationPrefix = 'payment-day-section.edit-view.monthly-payment-day';
    const [field, , helpers] = useField(name);

    const { onAction: onTyping } = useAnalyticsActionTracker('financialDetailsEditDueDateSectionStartTyping');
    const [selectedPaymentDay, setSelectedPaymentDay] = useState({
        isOpen: false,
        value: [],
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const setValueChange = (selectedPaymentDay: any) => {
        onTyping();
        helpers.setValue(selectedPaymentDay?.[0]?.value);
        setSelectedPaymentDay(prev => ({
            ...prev,
            value: selectedPaymentDay,
        }));
    };

    const options = new Array(30).fill(null).map((_, index: number) => {
        const day = index + 1;
        return {
            key: `${day}`,
            value: {
                textValue: `${day}`,
                content: (
                    <span>
                        <b>{day}</b>
                    </span>
                ),
            },
        };
    });

    const defaultState = {
        value: [
            {
                value: field.value,
                key: field.value,
            },
        ],
    };

    return (
        <Layout className={'o-layout--flush'}>
            <Layout.Item>
                <label htmlFor="payment-day-selection" className={'u-mb-xsmall'}>
                    {t(`${translationPrefix}.label`)}
                    <InfoIcon
                        aria-hidden="true"
                        text={t(`${translationPrefix}.tooltip`)}
                        labelId={t(`${translationPrefix}.tooltipAriaLabel`)}
                    />
                </label>
            </Layout.Item>
            <Layout.Item default={'1/3'}>
                <FormField type="select" id={'payment-day-selection'}>
                    <Combobox
                        aria-required="true"
                        id="payment-day-selection"
                        testId={testId}
                        options={options}
                        defaultState={defaultState}
                        onChange={setValueChange}
                        value={selectedPaymentDay.value}
                    />
                </FormField>
            </Layout.Item>
        </Layout>
    );
};
